import React from "react";
import { capitalize } from "../utils/functions.js";

export const StatusBadge = ({ status }) => {
  const getStatusConfig = (status) => {
    const statusLower = status?.toLowerCase();

    switch (statusLower) {
      case "pending":
        return {
          className: "status-badge status-badge--pending",
          text: capitalize(status),
        };
      case "unassigned":
        return {
          className: "status-badge status-badge--unassigned",
          text: capitalize(status),
        };
      case "inprogress":
        return {
          className: "status-badge status-badge--inprogress",
          text: "In Progress", // Special case for compound word
        };
      case "late":
        return {
          className: "status-badge status-badge--late",
          text: capitalize(status),
        };
      case "missed":
        return {
          className: "status-badge status-badge--missed",
          text: capitalize(status),
        };
      case "completed":
        return {
          className: "status-badge status-badge--completed",
          text: capitalize(status),
        };
      default:
        return {
          className: "status-badge status-badge--default",
          text: capitalize(status) || "Unknown",
        };
    }
  };

  const config = getStatusConfig(status);

  return <span className={config.className}>{config.text}</span>;
};
